import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Link as RouterLink } from 'react-router-dom';

//import { Button, Link as LinkMaterial, Typography } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Input } from '~/components/Form';
import { signInRequest } from '~/store/modules/auth/actions';
import { resetParams } from '~/store/modules/hooks/actions';

const schema = Yup.object().shape({
  username: Yup.string().required(),
  password: Yup.string().required(),
});




export default function SignIn() {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const LinkBehavior = React.forwardRef((props, ref) => (
    // <RouterLink ref={ref} to="/getting-started/installation/" {...props} />
    //console.log("DADAS"),
    <RouterLink ref={ref} to="/EsqueciMinhaSenha" {...props} />
  ));

  async function handleSubmit({ username, password }) {
    await setLoading(true);

    try {
      const domain = window.location.hostname.split('.')[0];
      await dispatch(signInRequest(domain, username, password));
      await dispatch(resetParams());
    } catch (err) {
      console.log(err);
    } finally {
      await setLoading(false);
    }
  }

  return (
    <Form schema={schema} onSubmit={handleSubmit}>
      <Input
        name="username"
        label="Nome de usuario"
        required
        variant="standard"
        size="medium"
      />

      <Input
        type="password"
        name="password"
        label="Senha"
        required
        variant="standard"
        size="medium"
      />

      <Button
        color="primary"
        variant="contained"
        fullWidth
        type="submit"
        disabled={loading}
      >
        {loading ? 'Carregando...' : 'Login'}
      </Button>

      <Button color="primary" component={LinkBehavior}>
        Esqueci minha senha
      </Button>


    </Form>
  );
}
